import {fr} from "./fr";

export const COMPLIANCE_LANGS = {
    fr: fr
};
